import React from "react";

export const ShopifyIcon = ({ color }) => {
  const active = color === "primary";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.4653 5.28348C20.448 5.17291 20.3375 5.11172 20.2462 5.10498C20.1551 5.09831 18.2265 4.97298 18.2265 4.97298C18.2265 4.97298 16.8872 3.80708 16.7402 3.67804C16.5931 3.54906 16.3058 3.58829 16.1943 3.61707C16.1779 3.62131 15.9016 3.69606 15.4447 3.82003C14.9973 2.69117 14.2077 1.65379 12.8186 1.65379C12.7802 1.65379 12.7407 1.65516 12.7013 1.65713C12.3062 1.19902 11.8168 1 11.3941 1C8.15815 1 6.61217 4.54691 6.12744 6.34933C4.87003 6.69096 3.97676 6.93383 3.86266 6.96526C3.1608 7.1583 3.1386 7.17769 3.04644 7.75757C2.97708 8.19659 1.14062 20.6491 1.14062 20.6491L15.4507 23L23.2044 21.5293C23.2044 21.5293 20.4825 5.39405 20.4654 5.28348H20.4653ZM14.6538 4.03451L13.443 4.36311C13.4434 4.28828 13.4438 4.21467 13.4438 4.13417C13.4438 3.43259 13.3327 2.8677 13.1546 2.4199C13.8703 2.49866 14.347 3.21274 14.6538 4.03451ZM12.2666 2.55902C12.4657 2.99622 12.595 3.62366 12.595 4.47034C12.595 4.51366 12.5946 4.55327 12.5942 4.59333C11.8067 4.8072 10.951 5.03939 10.0934 5.27235C10.575 3.6429 11.4775 2.85589 12.2666 2.55902ZM11.3052 1.76103C11.4449 1.76103 11.5856 1.80261 11.7203 1.88387C10.6832 2.31175 9.57156 3.38942 9.10212 5.5415L7.12539 6.07829C7.67524 4.43679 8.98085 1.76103 11.3051 1.76103H11.3052Z"
        fill={active ? "#1329FE" : "#5F6368"}
      />
      <path
        d="M20.2459 5.1049C20.1548 5.09823 18.2263 4.9729 18.2263 4.9729C18.2263 4.9729 16.8869 3.807 16.7399 3.67796C16.6849 3.62994 16.6107 3.60533 16.5332 3.59473L15.4512 22.9997L23.2041 21.5292C23.2041 21.5292 20.4822 5.39396 20.4651 5.2834C20.4477 5.17283 20.3372 5.11164 20.2459 5.1049Z"
        fill={active ? "#0D1CB1" : "#4D4D50"}
      />
      <path
        d="M12.8151 8.86173L11.8591 11.3553C11.8591 11.3553 11.0214 10.9633 9.99462 10.9633C8.48931 10.9633 8.41356 11.7915 8.41356 12.0003C8.41356 13.1391 11.7994 13.5755 11.7994 16.243C11.7994 18.3418 10.2812 19.6932 8.23416 19.6932C5.7777 19.6932 4.52148 18.3527 4.52148 18.3527L5.17922 16.4473C5.17922 16.4473 6.4705 17.4194 7.5601 17.4194C8.27208 17.4194 8.56169 16.9279 8.56169 16.5687C8.56169 15.0832 5.78392 15.0169 5.78392 12.5759C5.78392 10.5214 7.46578 8.5332 10.8608 8.5332C12.1689 8.5332 12.8151 8.86173 12.8151 8.86173Z"
        fill="white"
      />
    </svg>
  );
};

export const RentmanIcon = ({ color }) => {
  const active = color === "primary";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.5"
        y="1.5"
        width="21"
        height="21"
        fill={active ? "#1329FE" : "#5F6368"}
      />
      <rect
        x="7.72656"
        y="8.23438"
        width="3.12256"
        height="7.00001"
        transform="rotate(35 7.72656 8.23438)"
        fill="white"
      />
      <rect
        x="12.6934"
        y="8.24414"
        width="3.12358"
        height="7.00209"
        transform="rotate(35 12.6934 8.24414)"
        fill="white"
      />
      <rect
        x="17.7129"
        y="8.23633"
        width="3.11995"
        height="6.99542"
        transform="rotate(35 17.7129 8.23633)"
        fill="white"
      />
    </svg>
  );
};

export const WoocommerceIcon = ({ color }) => {
  const active = color === "primary";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.22913 5H21.7627C22.999 5 23.9997 6.01577 23.9997 7.27065V14.8393C23.9997 16.0942 22.999 17.1099 21.7627 17.1099H14.7577L15.7192 19.5L11.4907 17.1099H2.23888C1.00271 17.1099 0.00202513 16.0942 0.00202513 14.8393V7.27065C-0.0078177 6.02576 0.992776 5 2.22913 5Z"
        fill={active ? "#1329FE" : "#5F6368"}
      />
      <path
        d="M1.36906 7.03872C1.50564 6.8533 1.71047 6.75581 1.98363 6.73631C2.48121 6.69722 2.76412 6.9313 2.83236 7.43862C3.13477 9.47749 3.46643 11.2042 3.81758 12.6187L5.95394 8.55077C6.14911 8.18002 6.39303 7.98495 6.68569 7.96545C7.11493 7.9362 7.37825 8.20927 7.48558 8.78484C7.7295 10.0822 8.04165 11.1846 8.41231 12.1211C8.66597 9.64332 9.09521 7.85811 9.70003 6.75581C9.84626 6.48265 10.0609 6.34607 10.3438 6.32648C10.5683 6.30707 10.7731 6.37532 10.9584 6.52165C11.1437 6.66798 11.2413 6.8533 11.2608 7.07772C11.2706 7.2533 11.2413 7.39963 11.1633 7.54596C10.7828 8.24836 10.4706 9.42875 10.217 11.0675C9.97319 12.6577 9.88535 13.8966 9.94385 14.7844C9.96344 15.0281 9.92435 15.2428 9.82686 15.4282C9.70968 15.6428 9.5342 15.7598 9.30978 15.7793C9.05612 15.7988 8.7928 15.6818 8.53914 15.4184C7.63191 14.4916 6.91001 13.1064 6.38328 11.2627C5.74912 12.5113 5.28088 13.4478 4.97847 14.0721C4.4029 15.1745 3.91517 15.7403 3.50542 15.7696C3.24201 15.7891 3.01769 15.5647 2.82261 15.0965C2.32513 13.8186 1.78855 11.3504 1.21308 7.69229C1.17399 7.43862 1.23248 7.21421 1.36906 7.03872ZM22.333 8.57027C21.9818 7.9557 21.4647 7.58505 20.7722 7.43862C20.5868 7.39963 20.4113 7.38013 20.2453 7.38013C19.3089 7.38013 18.548 7.86786 17.9529 8.84343C17.4456 9.67257 17.192 10.5895 17.192 11.5944C17.192 12.3455 17.3481 12.9893 17.6602 13.5259C18.0114 14.1405 18.5285 14.5111 19.221 14.6574C19.4064 14.6965 19.5819 14.716 19.7479 14.716C20.6941 14.716 21.455 14.2283 22.0403 13.2527C22.5475 12.4137 22.8012 11.4968 22.8012 10.4921C22.8109 9.73116 22.6451 9.097 22.333 8.57027ZM21.1038 11.2724C20.9672 11.9163 20.7233 12.3942 20.3623 12.7162C20.0795 12.9698 19.8161 13.0771 19.5723 13.0283C19.3381 12.9796 19.143 12.7747 18.9967 12.3942C18.8795 12.0918 18.8211 11.7894 18.8211 11.5065C18.8211 11.2627 18.8406 11.0188 18.8894 10.7945C18.9772 10.3945 19.143 10.0042 19.4064 9.63357C19.7284 9.15549 20.0698 8.96051 20.4209 9.02875C20.6551 9.0775 20.8503 9.28242 20.9965 9.66282C21.1136 9.96523 21.1721 10.2676 21.1721 10.5505C21.1721 10.8042 21.1526 11.0481 21.1038 11.2724ZM16.2262 8.57027C15.875 7.9557 15.3482 7.58505 14.6654 7.43862C14.4801 7.39963 14.3045 7.38013 14.1386 7.38013C13.2021 7.38013 12.4412 7.86786 11.8461 8.84343C11.3389 9.67257 11.0852 10.5895 11.0852 11.5944C11.0852 12.3455 11.2413 12.9893 11.5535 13.5259C11.9046 14.1405 12.4217 14.5111 13.1143 14.6574C13.2997 14.6965 13.4752 14.716 13.6411 14.716C14.5873 14.716 15.3482 14.2283 15.9335 13.2527C16.4409 12.4137 16.6944 11.4968 16.6944 10.4921C16.6944 9.73116 16.5384 9.097 16.2262 8.57027ZM14.9873 11.2724C14.8507 11.9163 14.6068 12.3942 14.2459 12.7162C13.963 12.9698 13.6996 13.0771 13.4557 13.0283C13.2216 12.9796 13.0265 12.7747 12.8801 12.3942C12.7631 12.0918 12.7046 11.7894 12.7046 11.5065C12.7046 11.2627 12.7241 11.0188 12.7729 10.7945C12.8607 10.3945 13.0265 10.0042 13.2899 9.63357C13.6118 9.15549 13.9533 8.96051 14.3044 9.02875C14.5386 9.0775 14.7337 9.28242 14.88 9.66282C14.9972 9.96523 15.0556 10.2676 15.0556 10.5505C15.0654 10.8042 15.0361 11.0481 14.9873 11.2724Z"
        fill="white"
      />
    </svg>
  );
};

export const MoveTo = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6667 7.49984V4.1665L17.5 9.99984L11.6667 15.8332V12.4165C7.5 12.4165 4.58333 13.7498 2.5 16.6665C3.33333 12.4998 5.83333 8.33317 11.6667 7.49984Z"
        fill="white"
      />
    </svg>
  );
};
